import { render, staticRenderFns } from "./TurnoMetaModal.vue?vue&type=template&id=643071e4&scoped=true&"
import script from "./TurnoMetaModal.vue?vue&type=script&lang=js&"
export * from "./TurnoMetaModal.vue?vue&type=script&lang=js&"
import style0 from "./TurnoMetaModal.vue?vue&type=style&index=0&id=643071e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643071e4",
  null
  
)

export default component.exports